import React, {useState, useEffect} from "react";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from "react-router-dom";
import moment from "moment";
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";

import {DashboardAPI} from "./../../API/Caller/DashboardAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import Loader from "./../Loader";
//import DataLoader from "./../DataLoader";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";



const Dashboard = () =>{

	const [freshleadcount, setFreshLeadCount] = useState(0);
	const [followupcount, setFollowupCount] = useState(0);
	const [todayfollowupcount, setTodayFollowupCount] = useState(0);
	const [warmleadcount, setWarmLeadCount] = useState(0);	
	const [notifications, setNotifications] = useState([]);
	const [loading, setLoading] = useState(true);
	const [loggedname, setLoggedName] = useState("");

	const current = moment();

	useEffect(() =>{
		console.log('Caller dahboard');

		//DashboardAPI(setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setLoading, setNotifications);
		DashboardAPI(setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setLoading, setNotifications);
		
		/*DashboardStatsAPI(setLoading).then(result =>{
				console.log('Fresh count==' + result);
				console.log('pending count===' + result.pendingfollowup);
				console.log('today count===' + result.todayfollowup);
				console.log('warm count==' + result.warmcount);
				console.log('Notification list===' + result.followuplist);
				setFreshLeadCount(result.freshcount);
				setFollowupCount(result.pendingfollowup);
				setTodayFollowupCount(result.todayfollowup);
				setWarmLeadCount(result.warmcount);
				setNotifications(result.followuplist);
		});*/

	}, []);

	useEffect(() =>{
	
			const userinfo = localStorage.getItem("userinfo");
	
			if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
			{
				const loggeduserdata = JSON.parse(userinfo);
	
				setLoggedName(loggeduserdata.name);
			}
			
		}, []);

	const handleReloadStats = () =>{
		
		//DashboardAPI(setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setContactedLeadCount, setDeadLeadCount, setColdLeadCount, setAttemptLeadCount, setEnrolledLeadCount, setLoading, setNotifications, setTotalLeadCount);

		DashboardAPI(setFreshLeadCount, setFollowupCount, setTodayFollowupCount, setWarmLeadCount, setLoading, setNotifications);

		/*DashboardStatsAPI(setLoading).then(result =>{
				setFreshLeadCount(result.freshcount);
				setFollowupCount(result.pendingfollowup);
				setTodayFollowupCount(result.todayfollowup);
				setWarmLeadCount(result.warmcount);
				setNotifications(result.followuplist);
		});*/
	}


    return(
	<Layout>
		<div className="content">
			<div class="welcome-wrap mb-4">
				<div class=" d-flex align-items-center justify-content-between flex-wrap crm-welcome-bar">
					<div class="mb-3">
						<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
						<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
					</div>
					<div class="d-flex align-items-center flex-wrap mb-1 crm-top-actions">
						<button type="button" class="btn btn-light btn-md mb-2" onClick={handleReloadStats}>Refresh</button>
					</div>
				</div>
			</div>

			<div className="row crm-stats-row">
				<div className="col-md-3">
					<div className="card fresh">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/caller/lead/freshlead">
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card follow">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{todayfollowupcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Follow Up for Today</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/caller/notification/today">
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card warm">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{warmleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/caller/lead/warmleads">
									<span className="small fw-semibold">View all</span>
									<span>

										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card pending">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{followupcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to="/caller/notification/pending">
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row crm-report-row">
				<div className="col-md-8"></div>

				<div className="col-md-4">
					<div class="card flex-fill crm-right-card">
						<div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
							<h5 class="mb-2">Today Follow Ups</h5>
							<Link to="/caller/notifications" class="btn btn-light btn-md mb-2">View All</Link>
						</div>
						<div class="card-body crm-followup-body">
							{loading ?
								<ContentLoader />
							:
								(notifications && notifications.length > 0  ?
									( notifications.map(notification =>
										(
											<div class="crm-followup-list">
												<div class="crm-followup-item">
													<div class="crm-followup-item">
														<div class="crm-followup-top">
															<span class="crm-followup-name">{notification.name}</span>
															<span class="crm-followup-time">{notification.display_time}</span>
														</div>
														<div class="crm-followup-bottom">
															<span class="crm-followup-mobile">{notification.contact}</span>
															<span class="crm-followup-date">{moment(notification.display_date).format('DD MMM YYYY')}</span>
														</div>
													</div>
												</div>
											</div>
										)
									))
								:
									<p className="centered-message">No data found</p>
								)
							}

						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
    )
}

export default Dashboard;
